(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["byw-art-finder"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-byw-finder]').forEach((finder) => {
    const form = finder.querySelector('[data-finder-form]');
    const steps = [...form.querySelectorAll('[data-step]')];
    const next = finder.querySelector('[data-next]');
    const back = finder.querySelector('[data-back]');
    const results = finder.querySelector('[data-results]');
    const label = finder.querySelector('[data-step-label]');
    const progress = finder.querySelector('[data-progress]');
    let current = 0;

    const paint = () => {
      steps.forEach((step, index) => { step.hidden = index !== current; });
      label.textContent = `Step ${current + 1} of ${steps.length}`;
      progress.style.width = `${((current + 1) / steps.length) * 100}%`;
      back.hidden = current === 0;
      next.textContent = current === steps.length - 1 ? 'Show my art edit' : 'Continue';
      next.disabled = !steps[current].querySelector('input:checked');
    };

    form.addEventListener('change', () => { next.disabled = false; });
    back.addEventListener('click', () => { current -= 1; paint(); });
    next.addEventListener('click', () => {
      if (current < steps.length - 1) { current += 1; paint(); return; }
      const values = Object.fromEntries(new FormData(form));
      const scores = { calm: 0, statement: 0, focus: 0, family: 0, kids: 0 };
      if (values.room === 'kids') scores.kids += 6;
      if (values.room === 'prayer') scores.focus += 4;
      if (values.room === 'bedroom') scores.calm += 4;
      if (values.room === 'living') scores.statement += 2;
      if (values.mood === 'neutral') scores.calm += 5;
      if (values.mood === 'gold') scores.statement += 5;
      if (values.mood === 'faith') scores.focus += 5;
      if (values.mood === 'family') scores.family += 5;
      if (values.format === 'trio') scores.family += 5;
      if (values.format === 'canvas') scores.statement += 4;
      if (values.format === 'single') scores.focus += 2;
      if (values.format === 'unsure') scores.calm += 3;
      const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0];
      form.hidden = true;
      label.hidden = true;
      progress.parentElement.hidden = true;
      results.hidden = false;
      results.querySelectorAll('[data-result]').forEach((item) => { item.hidden = item.dataset.result !== winner; });
      results.focus();
    });
    finder.querySelector('[data-restart]').addEventListener('click', () => {
      form.reset(); current = 0; form.hidden = false; label.hidden = false; progress.parentElement.hidden = false; results.hidden = true; paint();
    });
    paint();
  });
  } catch(e) { console.error(e); }
})();

})();
